
<template>
  <div class="demoSystem">
    <!--<topfixed></topfixed>-->
    <div class="photoLists clearfix">
      <ul>
        <li v-for="(item,index) in imgs" :key="index">
          <span class="bg"></span>
          <a href="#">
            <img :src="'http://citgroup.cn'+item.logo">
            <!--<img src="../../assets/images/anli1.png">-->
            <p class="textp">
              <span class="stitle" v-text="item.title"></span>
              <br>
              <span class="sdescrip" v-text="item.description"></span>
            </p>
          </a>
        </li>
      </ul>
    </div>
    <!--加载更多按钮-->
    <div class="loadMore">
      <span class="moreSpan" v-if="demoMore" @click="moreDemoList()">加载更多</span>
      <span v-else="demoMore">已加载全部</span>
    </div>
  </div>
</template>

<script>
  import config from '../../assets/js/config.js'
//import topfixed from '../topfixed'
  export default {
    name: 'demoSystem',
    data () {
      return {
        msg: '',
        imgs:[],
        demoPage:2,
        demoMore:true
      }
    },
    mounted(){
      this.getPhotos();
    },
    methods:{
      getPhotos(){
        var that=this;
        that.$ajax.post(config.demoSystem.demoList,JSON.stringify({"page":1}))
          .then(function (response) {
            console.log(response.data.data.custSystems)
            that.imgs=response.data.data.custSystems;
            if(response.data.data.num<=10){
              that.demoMore=false;
            }
          })
      },
      moreDemoList(){
        var that=this;
        that.$ajax.post(config.demoSystem.demoList,JSON.stringify({"page":that.demoPage}))
          .then(function (response) {
            console.log(response.data.data.custSystems)
            let caseNum=Math.ceil(response.data.data.num/10);
            if(response.data.data.custSystems.length>0){
              if(that.demoPage>=caseNum){
                that.demoMore=false;
              }
              that.demoPage++;
            }
            that.imgs=that.imgs.concat(response.data.data.custSystems);

          })
      }
    },
    components:{
//    topfixed:topfixed
    }
  }
</script>

<style scoped>
  .demoSystem{
    margin-bottom: 1rem;
  }
  .topfixed-wrap{
    background: #010101!important;
  }
  .photoLists{
    width: 98%;
    margin: 0 auto;
    margin-top: 0.45rem;
  }
  ul{
    width: 100%;
    display: inline-block;
  }
  li{
    width: 100%;
    position: relative;
    margin-bottom: .08rem;
  }
  img{
    width: 100%;
    height: 3.1rem;
    vertical-align:middle;
  }
  .bg{
    position: absolute;
    width: 100%;
    height:100%;
    z-index: 2;
    background: rgba(0,0,0,.3);
  }
  .textp{
    position:absolute;
    width: 80%;
    margin: 0 10%;
    text-align: center;
    z-index: 3;
    top:33%;
    color: #fff
  }
  .stitle{
    font-size: 0.26rem;
    text-align: center;
  }
  .sdescrip{
    font-size: 0.2rem;
    color: #fefefecc;
    text-align: center;
  }
  .loadMore{
    padding: 0.2rem 0 1.6rem;
    font-size: 0.24rem;
  }
  .moreSpan{
    display: block;
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/demoSystem/demoSystem.vue